export const style = {
  main: {
    sx: {
      flexGrow: 1,
      py: 8,
    },
  },
  container: {
    maxWidth: 'lg',
  },
  loader: {
    sx: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      minHeight: '50vh',
    },
  },
} as const;

export default style;
